import {
  Component,
  ElementRef,
  forwardRef,
  Injector,
  Input,
  NgZone,
  OnChanges,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseReCaptchaComponentDirective } from './base-re-captcha-component.directive';
import { Parameters, ReCaptchaType, ScriptService } from '@core/recaptcha/data-access';

@Component({
  selector: 'core-feature-recaptcha-invisible',
  standalone: true,
  imports: [],
  template: '<div #captchaWrapperElem></div>',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InvisibleReCaptchaComponent),
      multi: true,
    },
  ],
})
export class InvisibleReCaptchaComponent extends BaseReCaptchaComponentDirective implements OnChanges {
  /**
   * This size representing invisible captcha
   */
  readonly size = 'invisible';

  recaptchaType: ReCaptchaType = ReCaptchaType.InvisibleReCaptcha;

  /**
   * Theme
   */
  @Input() theme: 'dark' | 'light' = 'light';

  /**
   * Badge
   */
  @Input() badge: 'bottomright' | 'bottomleft' | 'inline' = 'bottomright';

  @ViewChild('captchaWrapperElem', { static: false }) captchaWrapperElem!: ElementRef;

  constructor(renderer: Renderer2, zone: NgZone, injector: Injector, scriptService: ScriptService) {
    super(renderer, zone, injector, scriptService);
  }

  /**
   * Programatically invoke the reCAPTCHA check. Used if the invisible reCAPTCHA is on a div instead of a button.
   */
  execute(): void {
    // execute captcha
    this.zone.runOutsideAngular(() => this.reCaptchaApi?.execute(this.captchaId));
  }

  captchaSpecificSetup(): void {}

  /**
   * Gets reCaptcha properties
   */
  getCaptchaProperties(): Parameters {
    return {
      badge: this.badge,
      callback: (response: string) => this.zone.run(() => this.handleCallback(response)),
      'error-callback': () => this.zone.run(() => this.handleErrorCallback()),
      'expired-callback': () => this.zone.run(() => this.handleExpireCallback()),
      sitekey: this.siteKey,
      size: this.size,
      tabindex: this.tabIndex,
      theme: this.theme,
      type: this.type,
    };
  }
}
